import { Component, inject, input } from '@angular/core';
import { NxCardModule } from '@aposin/ng-aquila/card';
import { NxHeadlineModule } from '@aposin/ng-aquila/headline';
import { NxMessageModule } from '@aposin/ng-aquila/message';
import { TranslateModule } from '@ngx-translate/core';

import { DocumentInfoComponent } from '#components/document-info/document-info.component';
import UserService from '#services/user/user.service';

@Component({
  selector: 'kyc-document-list',
  imports: [NxCardModule, DocumentInfoComponent, NxHeadlineModule, NxMessageModule, TranslateModule],
  templateUrl: './document-list.component.html',
  styleUrl: './document-list.component.scss',
})
export class DocumentListComponent {
  readonly documentIds = input.required<string[]>();
  protected readonly userService: UserService = inject(UserService);
}
